import React from 'react';
import Details from '../../components/details/details';
import Form from '../../components/form/form';
import Greetins from '../../components/greetings/greetings';
import Info from '../../components/info/info';
import Links from '../../components/links/links';
import Wishes from '../../components/wishes/wishes';

function Main() {

  return (
    <div>
      <Greetins />
      <Info />
      <Details />
      <Form />
      <Wishes />
      <Links />
    </div>
  );
}

export default Main;
